/* eslint-disable max-len */
import React from "react";

export const SortUpIcon: React.FC = () => {
  return  (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.664062" width="24" height="24" rx="3" fill="#DDE5E9"/>
      <path d="M5.99674 12.0003L7.17174 13.1753L11.8301 8.52533L11.8301 18.667L13.4967 18.667L13.4967 8.52533L18.1467 13.1837L19.3301 12.0003L12.6634 5.33366L5.99674 12.0003Z" fill="#2B3337"/>
    </svg>
  );
};
